import dateFormat from "dateformat";

const formatDate = (seconds: number) => dateFormat(seconds * 1000, "dS mmmm yyyy");

const getNumberWithOrdinal = (n: number) => {
    const suffix = ["th", "st", "nd", "rd"],
        v = n % 100;
    // find s[v%10] if >= 20 (20th...99th), if not found, try suffix[v] (0th..3rd), C. if still not found, use th (4th..19th)
    return n + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]);
};

export {formatDate, getNumberWithOrdinal};
